import React, { useRef, useState } from "react";
import { Loader } from "../../components";

import useSectionHeight from "./hooks/useSectionHeight";
import useDashboardData from "./hooks/useDashboardData";
import { AnalyticsSection, ApplicationsSection, OverviewCard, ReviewsSection } from "./components";

import styles from './DashboardPage.module.scss';

function DashboardPage() {
	const [activePlatform, setActivePlatform] = useState("playStore");
	const [selectedApp, setSelectedApp] = useState("");
	const applicationsSectionRef = useRef(null);
	const reviewsSectionRef = useRef(null);
	const headerRef = useRef(null);

	const {
		overviewData,
		appListData,
		reviewData,
		analyticsData,
		isLoading,
		error
	} = useDashboardData();

	const { applicationsSectionHeight, reviewsSectionHeight } = useSectionHeight(headerRef);

	const filteredApps = appListData?.map((app) => {
		let platform = null;
		if (activePlatform === "playStore") {
			if (app.stores.some(store => store.storeType === "play_store")) {
				platform = "playStore";
			}
		} else if (activePlatform === "appleStore") {
			if (app.stores.some(store => store.storeType === "apple_store")) {
				platform = "appleStore";
			}
		}
		return { ...app, platform };
	}).filter(app => app.platform !== null) || [];

	const handleAppSelection = (event) => {
		setSelectedApp(event.target.value);
	};

	if (isLoading) {
		return <Loader loading={isLoading} />
	}
	if (error) {
		return <div>Failed while trying to load data</div>;
	}

	return (
		<>
			<div className={styles.dashboard}>
				<div className={styles.mainContent}>
					<div className={styles.overview}>
						{overviewData?.map((item, index) => (
							<OverviewCard
								key={index}
								icon={item.icon}
								label={item.label}
								value={item.value}
							/>
						))}
					</div>
					<AnalyticsSection
						activePlatform={activePlatform}
						setActivePlatform={setActivePlatform}
						selectedApp={selectedApp}
						appListData={appListData || []}
						handleAppSelection={handleAppSelection}
						analyticsData={analyticsData}
					/>
				</div>
				<div className={styles.sideSection}>
					<div
						className={styles.applicationsSection}
						style={{ maxHeight: applicationsSectionHeight }}
						ref={applicationsSectionRef}
					>
						<ApplicationsSection applications={filteredApps} />
					</div>
					<div
						className={styles.reviewsSection}
						style={{ maxHeight: reviewsSectionHeight }}
						ref={reviewsSectionRef}
					>
						<ReviewsSection reviewData={reviewData} />
					</div>
				</div>
			</div>
		</>
	);
}

export { DashboardPage };
